(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/^salford\s+(rum|gin)\s*-\s*/, '')
      .replace(/^salford\s+distillery\s*-\s*/, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function aliases(value) {
    var name = normalise(value);
    var list = [name];
    if (name.indexOf('honey') !== -1) list.push('honey rum', 'spiced honey');
    if (name.indexOf('coffee') !== -1) list.push('coffee rum');
    if (name.indexOf('original dry') !== -1 || name === 'salford gin') list.push('original dry gin');
    if (name.indexOf('original golden') !== -1 || name === 'original spiced' || name === 'spiced rum') {
      list.push('original golden spiced', 'original spiced rum', 'original golden spiced rum');
    }
    if (name.indexOf('dark') !== -1) list.push('dark spice', 'dark spiced', 'dark spice rum', 'dark spiced rum');
    if (name.indexOf('rhubarb') !== -1) list.push('rhubarb gin');
    if (name.indexOf('cherry') !== -1) list.push('cherry rum', 'cherry spiced', 'salford cherry spiced rum');
    if (name.indexOf('black') !== -1) list.push('rum black', 'rum and black', 'rum black spiced');
    return list.filter(function (item, index, self) {
      return item && self.indexOf(item) === index;
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((cents || 0) / 100);
  }

  function bottleNote(name) {
    var key = normalise(name);
    if (key.indexOf('original dry') !== -1) return 'Classic dry gin with citrus and juniper.';
    if (key.indexOf('original golden') !== -1 || key.indexOf('spiced') !== -1) return 'Warm spices, vanilla and smooth caramel.';
    if (key.indexOf('dark') !== -1) return 'Deep spice and rich molasses warmth.';
    if (key.indexOf('honey') !== -1) return 'Rich honey with warming spices.';
    if (key.indexOf('coffee') !== -1) return 'Bold coffee with smooth rum.';
    if (key.indexOf('rhubarb') !== -1) return 'Bright rhubarb with a tart gin finish.';
    if (key.indexOf('cherry') !== -1) return 'Sweet cherry with a smooth rum base.';
    if (key.indexOf('black') !== -1) return 'Berry-dark rum with a cola-ready finish.';
    return 'Award-winning Salford spirit for summer serves.';
  }

  function bottleDetail(name) {
    var key = normalise(name);
    if (key.indexOf('original dry') !== -1 || key === 'salford gin') return '40% ABV · 70cl';
    if (key.indexOf('dark') !== -1) return '40% ABV · 70cl';
    if (key.indexOf('original golden') !== -1 || key.indexOf('spiced') !== -1) return '40% ABV · 70cl';
    if (key.indexOf('honey') !== -1) return '37.5% ABV · 50cl';
    if (key.indexOf('coffee') !== -1) return '37.5% ABV · 70cl';
    if (key.indexOf('black') !== -1) return '28% ABV · 70cl';
    if (key.indexOf('cherry') !== -1) return '37.5% ABV · 70cl';
    if (key.indexOf('rhubarb') !== -1) return '40% ABV · 70cl';
    return '';
  }

  function bottleNoteText(bottle) {
    return bottle && (bottle.note || bottleNote(bottle.label));
  }

  function bottleDetailText(bottle) {
    return bottle && (bottle.detail || bottleDetail(bottle.label));
  }

  function getVariantOptions(variant) {
    if (variant.options) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  ready(function () {
    document.querySelectorAll('[data-s90]').forEach(function (root) {
      if (root.dataset.s90Ready === 'true') return;
      root.dataset.s90Ready = 'true';

      var dataNode = root.querySelector('[data-s90-data]');
      if (!dataNode) return;

      var data;
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      var product = data.product || {};
      var variants = product.variants || [];
      var bottles = data.bottles || [];
      var copy = data.copy || {};
      var savings = data.savings || {};

      if (!bottles.length && variants.length) {
        var seenBottleValues = [];
        variants.forEach(function (variant) {
          var value = getVariantOptions(variant)[0];
          if (value && seenBottleValues.indexOf(value) === -1) {
            seenBottleValues.push(value);
            bottles.push({
              value: value,
              label: value,
              note: bottleNote(value),
              detail: bottleDetail(value),
              image: null,
              imageAlt: value
            });
          }
        });
      }

      bottles.forEach(function (bottle) {
        bottle.available = bottleHasAvailableVariant(bottle);
      });

      var state = {
        activeSlot: 0,
        openSlot: null,
        slots: [null, null, null],
        adding: false
      };

      function query(selector) {
        return root.querySelector(selector);
      }

      function queryAll(selector) {
        return Array.prototype.slice.call(root.querySelectorAll(selector));
      }

      function soldOutLabel() {
        return copy.soldOutLabel || 'Sold out';
      }

      function soldOutMessage() {
        return copy.soldOutMessage || 'This bottle is currently sold out.';
      }

      function selectedCount() {
        return state.slots.filter(Boolean).length;
      }

      function nextEmptySlot() {
        var index = state.slots.findIndex(function (slot) {
          return !slot;
        });
        return index === -1 ? 2 : index;
      }

      function variantIsAvailable(variant) {
        return variant && variant.available !== false;
      }

      function bottleMatchesVariant(bottle, variant) {
        var bottleAliases = aliases(bottle.value || bottle.label);
        return getVariantOptions(variant).map(normalise).some(function (option) {
          return bottleAliases.indexOf(option) !== -1;
        });
      }

      function bottleHasAvailableVariant(bottle) {
        if (!bottle || !variants.length) return true;
        return variants.some(function (variant) {
          return variantIsAvailable(variant) && bottleMatchesVariant(bottle, variant);
        });
      }

      function isBottleAvailable(bottle) {
        return !bottle || bottle.available !== false;
      }

      function matchingVariant() {
        if (selectedCount() !== 3) return null;
        var selectedAliases = state.slots.map(function (bottle) {
          return aliases(bottle.value || bottle.label);
        });

        return variants.find(function (variant) {
          var options = getVariantOptions(variant).map(normalise);
          return selectedAliases.every(function (nameAliases, index) {
            return nameAliases.indexOf(options[index]) !== -1;
          });
        }) || null;
      }

      function currentVariantPrice(variant) {
        return variant && variant.price ? variant.price : product.price;
      }

      function savingText(amount, rrp) {
        var percent = rrp > 0 ? Math.round((amount / rrp) * 100) : 0;
        if (savings.mode === 'percent') return percent + '%';
        if (savings.mode === 'both') return formatMoney(amount) + ' (' + percent + '%)';
        return formatMoney(amount);
      }

      function updateSavings(priceCents) {
        var node = query('[data-s90-savings]');
        if (!node) return;

        var rrp = Number(savings.rrp) || 0;
        var price = Number(priceCents) || 0;
        var amount = rrp - price;
        node.hidden = !savings.show || rrp <= 0 || amount <= 0;
        if (node.hidden) return;

        var rrpNode = node.querySelector('span');
        var savingNode = node.querySelector('strong');
        if (rrpNode) rrpNode.textContent = (savings.rrpLabel || 'RRP') + ' ' + formatMoney(rrp);
        if (savingNode) savingNode.textContent = (savings.savingLabel || 'Save') + ' ' + savingText(amount, rrp);
      }

      function renderSlots() {
        queryAll('[data-s90-slot]').forEach(function (slot) {
          var index = Number(slot.getAttribute('data-s90-slot'));
          var bottle = state.slots[index];
          var media = slot.querySelector('[data-s90-slot-media]');
          var name = slot.querySelector('[data-s90-slot-name]');
          var wrap = query('[data-s90-slot-wrap="' + index + '"]');
          var soldOut = bottle && !isBottleAvailable(bottle);
          slot.classList.toggle('is-active', index === state.activeSlot);
          slot.classList.toggle('has-bottle', Boolean(bottle));
          slot.classList.toggle('is-sold-out', Boolean(soldOut));
          slot.setAttribute('aria-expanded', state.openSlot === index ? 'true' : 'false');
          if (wrap) {
            wrap.classList.toggle('is-open', state.openSlot === index);
            wrap.classList.toggle('is-active', state.activeSlot === index);
            wrap.classList.toggle('has-bottle', Boolean(bottle));
            wrap.classList.toggle('is-sold-out', Boolean(soldOut));
          }
          if (media) {
            media.innerHTML = bottle && bottle.image
              ? '<img src="' + bottle.image + '" alt="" loading="lazy">'
              : '<span aria-hidden="true">+</span>';
          }
          if (name) {
            if (bottle) {
              var detail = bottleDetailText(bottle);
              name.innerHTML = '<strong>' + escapeHtml(bottle.label) + '</strong>' +
                (detail ? '<small>' + escapeHtml(detail) + '</small>' : '') +
                (soldOut ? '<span class="s90-soldout-badge">' + escapeHtml(soldOutLabel()) + '</span>' : '') +
                '<em>' + escapeHtml(copy.changeBottle || 'Change bottle') + '</em>';
            } else {
              name.textContent = copy.selectBottle;
            }
          }
        });
      }

      function renderProducts() {
        var container = query('[data-s90-products]');
        if (!container) return;
        container.innerHTML = bottles.map(function (bottle) {
          var selected = state.slots.some(function (slot) {
            return slot && slot.value === bottle.value;
          });
          var available = isBottleAvailable(bottle);
          return '<article class="s90-choice-card' + (available ? '' : ' is-sold-out') + '" aria-selected="' + (selected ? 'true' : 'false') + '"' + (available ? '' : ' aria-disabled="true"') + '>' +
            (bottle.image ? '<img src="' + bottle.image + '" alt="' + escapeHtml(bottle.imageAlt || bottle.label) + '" loading="lazy">' : '<span></span>') +
            '<div><strong>' + escapeHtml(bottle.label) + '</strong>' +
            (bottleDetailText(bottle) ? '<span class="s90-bottle-detail">' + escapeHtml(bottleDetailText(bottle)) + '</span>' : '') +
            '<small>' + escapeHtml(bottleNoteText(bottle)) + '</small>' +
            '<em>' + escapeHtml(available ? (copy.includedLabel || '') : soldOutLabel()) + '</em></div>' +
            '<button class="s90-choice-card__button" type="button" data-s90-bottle="' + escapeHtml(bottle.value) + '"' + (available ? '' : ' disabled aria-disabled="true"') + '>' + escapeHtml(available ? (selected ? copy.selectedLabel : copy.addLabel) : soldOutLabel()) + '</button>' +
          '</article>';
        }).join('');
      }

      function renderPickers() {
        queryAll('[data-s90-picker]').forEach(function (picker) {
          var slotIndex = Number(picker.getAttribute('data-s90-picker'));
          picker.innerHTML = bottles.map(function (bottle) {
            var selected = state.slots[slotIndex] && state.slots[slotIndex].value === bottle.value;
            var available = isBottleAvailable(bottle);
            return '<button type="button" class="s90-picker-option' + (available ? '' : ' is-sold-out') + '" data-s90-picker-option data-slot-index="' + slotIndex + '" data-bottle-value="' + escapeHtml(bottle.value) + '" aria-selected="' + (selected ? 'true' : 'false') + '"' + (available ? '' : ' disabled aria-disabled="true"') + '>' +
              (bottle.image ? '<img src="' + bottle.image + '" alt="" loading="lazy">' : '<span></span>') +
              '<span><strong>' + escapeHtml(bottle.label) + '</strong>' +
              (bottleDetailText(bottle) ? '<span class="s90-bottle-detail">' + escapeHtml(bottleDetailText(bottle)) + '</span>' : '') +
              '<small>' + escapeHtml(bottleNoteText(bottle)) + '</small></span>' +
              '<i aria-hidden="true">' + (available ? (selected ? '✓' : '+') : escapeHtml(soldOutLabel())) + '</i>' +
            '</button>';
          }).join('');
        });
      }

      function updateSummary() {
        var variant = matchingVariant();
        var add = query('[data-s90-add]');
        var input = query('[data-s90-variant-id]');
        var price = query('[data-s90-price]');
        var helper = query('[data-s90-helper]');
        var message = query('[data-s90-message]');
        var count = selectedCount();
        var unavailable = count === 3 && (!variant || variant.available === false);
        var activePrice = currentVariantPrice(variant);

        if (input) input.value = variant && variant.id ? variant.id : '';
        if (price) price.textContent = 'Total: ' + formatMoney(activePrice);
        updateSavings(activePrice);
        if (helper) {
          helper.textContent = count < 3
            ? copy.chooseThree.replace('[count]', String(3 - count))
            : unavailable
              ? copy.unavailable
              : copy.ready;
        }
        if (add) {
          add.disabled = state.adding || count !== 3 || unavailable;
          add.textContent = state.adding
            ? copy.adding
            : count === 3 && !unavailable
              ? copy.addToCart.replace('[price]', formatMoney(currentVariantPrice(variant)))
              : copy.chooseThreeButton;
        }
        if (message && count < 3) message.textContent = '';
      }

      function updateView() {
        renderSlots();
        renderPickers();
        renderProducts();
        updateSummary();
      }

      function cartTarget() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      function cartSections() {
        var cart = cartTarget();
        if (cart && typeof cart.getSectionsToRender === 'function') {
          return cart.getSectionsToRender().map(function (section) {
            return section.id;
          }).filter(Boolean);
        }

        return ['cart-drawer', 'cart-icon-bubble', 'cart-notification-product', 'cart-notification-button'];
      }

      function publishCartUpdate(cartState, variantId) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          var update = publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'section-3-for-90',
            productVariantId: String(variantId),
            cartData: cartState,
            variantId: variantId
          });

          if (update && typeof update.then === 'function') {
            return update.catch(function () {});
          }
        }

        return Promise.resolve();
      }

      function renderCart(cartState) {
        var cart = cartTarget();
        if (cart && cartState && cartState.sections && typeof cart.renderContents === 'function') {
          if (cart.classList && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
          cart.renderContents(cartState);
          return true;
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cartState } }));

        if (cart && typeof cart.open === 'function') {
          cart.open();
          return true;
        }

        return false;
      }

      function chooseBottle(value, slotIndex) {
        var bottle = bottles.find(function (item) {
          return item.value === value;
        });
        if (!bottle) return;
        if (!isBottleAvailable(bottle)) {
          var message = query('[data-s90-message]');
          if (message) message.textContent = soldOutMessage();
          return;
        }
        var target = Number.isInteger(slotIndex)
          ? slotIndex
          : state.slots[state.activeSlot]
            ? nextEmptySlot()
            : state.activeSlot;
        state.slots[target] = bottle;
        if (selectedCount() < 3) {
          state.activeSlot = nextEmptySlot();
          state.openSlot = null;
        } else {
          state.activeSlot = target;
          state.openSlot = null;
        }
        updateView();
      }

      function addToCart() {
        if (state.adding) return;
        var variant = matchingVariant();
        var message = query('[data-s90-message]');
        if (!variant || variant.available === false) {
          if (message) message.textContent = copy.unavailable;
          return;
        }

        var properties = {};
        properties[copy.propertyName || '_Bundle Offer'] = copy.propertyValue || '3 for 90 summer bundle';
        state.slots.forEach(function (bottle, index) {
          properties['Bottle ' + (index + 1)] = bottle.label;
        });

        state.adding = true;
        updateSummary();
        if (message) message.textContent = '';

        var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        var cart = cartTarget();
        if (cart && typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }

        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variant.id,
              quantity: 1,
              properties: properties
            }],
            sections: cartSections().join(','),
            sections_url: window.location.pathname
          })
        }).then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              throw new Error(error.description || copy.error);
            });
          }
          return response.json();
        }).then(function (cartState) {
          if (message) message.textContent = copy.added;
          return publishCartUpdate(cartState, variant.id).then(function () {
            if (!renderCart(cartState) && window.routes && window.routes.cart_url) {
              window.location = window.routes.cart_url;
            }
          });
        }).catch(function (error) {
          if (message) message.textContent = error.message || copy.error;
        }).finally(function () {
          state.adding = false;
          updateSummary();
        });
      }

      function tickCountdown() {
        queryAll('[data-s90-countdown]').forEach(function (countdown) {
          var end = new Date(countdown.getAttribute('data-s90-countdown'));
          if (Number.isNaN(end.getTime())) return;
          var distance = end.getTime() - Date.now();
          if (distance <= 0) {
            Array.prototype.slice.call(countdown.querySelectorAll('[data-s90-time]')).forEach(function (node) {
              node.textContent = '00';
            });
            var ended = countdown.querySelector('[data-s90-ended]');
            if (ended) ended.textContent = copy.offerEnded;
            return;
          }
          var parts = {
            days: Math.floor(distance / 86400000),
            hours: Math.floor(distance / 3600000) % 24,
            mins: Math.floor(distance / 60000) % 60,
            secs: Math.floor(distance / 1000) % 60
          };
          Object.keys(parts).forEach(function (key) {
            var node = countdown.querySelector('[data-s90-time="' + key + '"]');
            if (node) node.textContent = String(parts[key]).padStart(2, '0');
          });
        });
      }

      function initTrustAutoScroll() {
        var track = query('.s90-trust__grid');
        var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.s90-benefit:not([data-s90-trust-clone])')) : [];
        if (!track || slides.length < 2) return;

        var mobile = window.matchMedia('(max-width: 989px)');
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var frame = null;
        var lastTime = 0;
        var speed = 0.035;

        function ensureClones() {
          if (track.dataset.s90TrustCloned === 'true') return;
          slides.forEach(function (slide) {
            var clone = slide.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-s90-trust-clone', 'true');
            track.appendChild(clone);
          });
          track.dataset.s90TrustCloned = 'true';
        }

        function stop() {
          if (frame) window.cancelAnimationFrame(frame);
          frame = null;
          lastTime = 0;
        }

        function animate(timestamp) {
          if (!lastTime) lastTime = timestamp;
          var delta = timestamp - lastTime;
          lastTime = timestamp;

          var loopWidth = track.scrollWidth / 2;
          if (loopWidth > 0) {
            track.scrollLeft += delta * speed;
            if (track.scrollLeft >= loopWidth) {
              track.scrollLeft -= loopWidth;
            }
          }

          frame = window.requestAnimationFrame(animate);
        }

        function start() {
          stop();
          ensureClones();
          if (!mobile.matches || reducedMotion.matches) {
            track.scrollLeft = 0;
            return;
          }
          frame = window.requestAnimationFrame(animate);
        }

        if (mobile.addEventListener) {
          mobile.addEventListener('change', start);
          reducedMotion.addEventListener('change', start);
        } else if (mobile.addListener) {
          mobile.addListener(start);
          reducedMotion.addListener(start);
        }

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stop();
          else start();
        });

        start();
      }

      root.addEventListener('click', function (event) {
        var option = event.target.closest('[data-s90-picker-option]');
        if (option) {
          chooseBottle(option.getAttribute('data-bottle-value'), Number(option.getAttribute('data-slot-index')));
          return;
        }

        var slot = event.target.closest('[data-s90-slot]');
        if (slot) {
          var slotIndex = Number(slot.getAttribute('data-s90-slot')) || 0;
          state.activeSlot = slotIndex;
          state.openSlot = state.openSlot === slotIndex ? null : slotIndex;
          updateView();
          return;
        }

        var bottle = event.target.closest('[data-s90-bottle]');
        if (bottle) {
          chooseBottle(bottle.getAttribute('data-s90-bottle'));
          return;
        }

        if (event.target.closest('[data-s90-add]')) {
          addToCart();
        }
      });

      var form = query('[data-s90-form]');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          addToCart();
        });
      }

      updateView();
      tickCountdown();
      initTrustAutoScroll();
      window.setInterval(tickCountdown, 1000);
    });
  });
})();
